exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".note-list-view{color:#87a6bc;font-family:Merriweather,Georgia,Times New Roman,Times,serif;font-size:14px;margin-bottom:12px;clear:left}.note-list-view .avatar{height:48px;width:48px;float:left;margin-right:12px;-webkit-clip-path:circle(24px at center);clip-path:circle(24px at center)}.note-list-view .icon{height:14px;width:14px;background-color:#87a6bc;border-radius:12px;fill:#fff;border:2px solid #fff;padding:3px;position:relative;left:-28px;top:30px}.note-list-view .subject:not(.excerpt){color:#2e4453}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/note-list-view.scss
 ** module id = 390
 ** module chunks = 0
 **/